import { Button } from 'antd'
import { useRouteMatches } from 'hooks/useRouteMatches'

function DeepLinkHeaderActionButton() {
  const { replaceHistory } = useRouteMatches()
  return (
    <Button
      onClick={() => replaceHistory({ key: 'deepLink', action: 'remove' })}
    >
      Show All
    </Button>
  )
}

export default DeepLinkHeaderActionButton
